import { render, staticRenderFns } from "./MinMaxProductPrice.vue?vue&type=template&id=3bee4a44&scoped=true&lang=pug&"
import script from "./MinMaxProductPrice.vue?vue&type=script&lang=js&"
export * from "./MinMaxProductPrice.vue?vue&type=script&lang=js&"
import style0 from "./MinMaxProductPrice.vue?vue&type=style&index=0&id=3bee4a44&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bee4a44",
  null
  
)

export default component.exports